import apiClient from './apiClient';
import type { PdfPrefs } from '@/stores/usePdfPrefsStore';

/**
 * Per-doctor PDF document preferences (template, accent colour, signature,
 * credentials line), stored under the existing `users.preferences` jsonb so
 * they're per-user, not per-device.
 *
 * Frontend role mirrors voicePrefsApi:
 *   - On post-auth boot: GET, then hydrate `usePdfPrefsStore` so the doctor's
 *     document look follows them to a new device on first launch.
 *   - On change: PUT (debounced) so other devices pick it up on next boot.
 *
 * Sending an empty string / null for a field clears it server-side (back to
 * the clinic default); omitting a field leaves it untouched.
 */

const BASE = '/users/me/pdf-prefs';

export const pdfPrefsApi = {
  async get(): Promise<PdfPrefs & { identityLine?: string }> {
    const res = await apiClient.get<PdfPrefs & { identityLine?: string }>(BASE);
    return res.data ?? {};
  },

  async put(next: Partial<PdfPrefs>): Promise<PdfPrefs> {
    const res = await apiClient.put<PdfPrefs>(BASE, next);
    return res.data ?? {};
  },
};
